import {
  FETCH_STALL_LIST_FAILURE,
  FETCH_STALL_LIST_REQUEST,
  FETCH_STALL_LIST_RESET,
  FETCH_STALL_LIST_SUCCESS,
} from "../../../types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const fetchStallListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STALL_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case FETCH_STALL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "PVS details fetched successfully",
      }

    case FETCH_STALL_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to fetch PVS details",
      }

    case FETCH_STALL_LIST_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default fetchStallListReducer
